<template>
	<div>
		<v-dialog v-model="dialog_logo_margin" v-if="dialog_logo_margin" no-click-animation persistent lazy full-width width="290px" transition="dialog-bottom-transition">
        	<v-card>
				<v-card-title class="title noshadow">
					Logo Margin
				</v-card-title>
        	  	<v-card-text>
        	  		<v-form>
						  <v-text-field
                            type="number"
        	  			    placeholder="Enter Left Margin" 
        	  			    v-model="logoLeftMargin"
                            :hide-details="true"
        	  			></v-text-field>
                        <div right-align light-opacity-color class="mb-3">px</div>
        	  		</v-form>
        	  	</v-card-text>
		        <v-card-actions>
		          <v-spacer></v-spacer>
		          <v-btn color="blue darken-1" flat @click.native="closeDialogWeb">cancel</v-btn>
		          <v-btn color="blue darken-1" flat @click.native="fn_changeMargin">Done</v-btn>
		        </v-card-actions>
	        	</v-card>	
      	</v-dialog>
	</div>
</template>

<script>
export default{
	props:['header'],
	data(){	
		return{
			dialog_logo_margin: false,
			logoLeftMargin:null
		}
	},
	methods:{
		openDialogWeb: function () {	
			this.dialog_logo_margin = true;
            if(this.$parent.$refs['ref_previewTemplate'].invoiceFieldsObj.logoLeftMargin.value){
                this.logoLeftMargin = this.$parent.$refs['ref_previewTemplate'].invoiceFieldsObj.logoLeftMargin.value;
            }
		},
		closeDialogWeb: function () {
			this.dialog_logo_margin = false;
		},
        fn_changeMargin: function(){
            if(this.logoLeftMargin < 0){
                this.showToast('Enter valid margin');
            }
            else{
                this.$parent.fn_changeMargin(this.logoLeftMargin);
            }
        }
	}
}
</script>


// WEBPACK FOOTER //
// src/components/invoice_templates/dialogs/dialog_logo_margin.vue